
import { useState, useEffect } from 'react';
import { useToast } from '@/hooks/use-toast';
import { supabase } from '@/integrations/supabase/client';

export interface DefaultCashbackTemplate {
  id: string;
  name: string;
  percentage: number;
  multiplier: number;
  expiration_days: number;
  discount_type: 'calculated' | 'fixed_percentage';
  is_active: boolean;
}

export const useDefaultCashbackTemplate = () => {
  const [template, setTemplate] = useState<DefaultCashbackTemplate | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const fetchDefaultTemplate = async () => {
    try {
      setIsLoading(true);
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error('Usuário não autenticado');

      const { data, error } = await supabase
        .from('cashback_templates')
        .select('id, name, percentage, multiplier, expiration_days, discount_type, is_active')
        .eq('user_id', user.id)
        .eq('is_default', true)
        .single();

      if (error && error.code !== 'PGRST116') {
        throw error;
      }

      if (data) {
        setTemplate({
          ...data,
          discount_type: data.discount_type as 'calculated' | 'fixed_percentage'
        });
      } else {
        setTemplate(null);
      }
    } catch (error: any) {
      console.error('Erro ao carregar template padrão:', error);
      toast({
        title: "Erro ao carregar template padrão",
        description: error.message,
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDefaultTemplate();
  }, []);

  return {
    template,
    isLoading,
    refetch: fetchDefaultTemplate
  };
};
